import { render, staticRenderFns } from "./TamanioCreate.vue?vue&type=template&id=0ffe7968&scoped=true&"
import script from "./TamanioCreate.vue?vue&type=script&lang=js&"
export * from "./TamanioCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffe7968",
  null
  
)

export default component.exports